import { Box } from '@factorialco/deprecated-design-system'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { useRequisition } from 'modules/ats/hooks/requisitions/useRequisition'

import type { CollapseContentData } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/AtsApprovals/types'

export interface Overlaps {
  in_team: number[]
  overlaps: number[]
}

interface Props {
  collapseContentData: CollapseContentData
}

const RightBlock = ({ collapseContentData }: Props) => {
  const { loading, requisition } = useRequisition(collapseContentData.resourceId)

  if (loading || !requisition) {
    return null
  }

  return (
    <Box width="full" gap="s12">
      <TextField
        readonly
        label={i18n.t('dashboard.todo.approvals.ats.job_opening_title')}
        value={requisition.jobPostingTitle}
      />

      <TextField
        readonly
        label={i18n.t('dashboard.todo.approvals.ats.team')}
        value={requisition.team?.name}
      />

      <TextField
        readonly
        label={i18n.t('dashboard.todo.approvals.ats.location')}
        value={requisition.workplace?.city || ''}
      />

      <TextField
        readonly
        label={i18n.t('dashboard.todo.approvals.ats.reason')}
        value={requisition.reason}
      />

      <TextField
        readonly
        label={i18n.t('dashboard.todo.approvals.ats.hiring_manager')}
        value={requisition.hiringManager?.fullName}
      />

      <TextField
        readonly
        label={i18n.t('dashboard.todo.approvals.ats.requisition_owner')}
        value={requisition.recruiter?.fullName}
      />
    </Box>
  )
}

export default RightBlock
